function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M361.964 153.896C353.745 137.035 335.434 128.635 322.562 115.279C307.756 99.9292 300.625 78.6568 291.68 59.016C282.736 39.3752 270.045 19.4323 250.284 12.6033C232.758 6.49958 213.722 12.0594 195.35 10.2464C166.644 7.40608 141.504 -9.27347 114.43 7.10391C80.95 27.349 53.1507 57.0217 32.543 90.9247C23.9011 105.126 13.3857 123.256 6.67765 142.232C-0.453463 162.417 -3.23339 183.508 5.22725 201.699C18.8247 230.767 45.8988 235.118 73.2146 229.135C104.64 222.306 137.092 220.131 169.062 225.086C193.416 228.894 217.469 236.448 241.581 240.436C277.056 245.815 306.91 237.112 309.689 236.025C316.7 233.426 324.133 229.921 331.204 225.691C332.835 224.724 334.467 223.696 336.038 222.669C336.099 222.609 336.22 222.548 336.28 222.488C336.764 222.185 337.247 221.823 337.67 221.521C339.12 220.554 340.51 219.526 341.84 218.439C342.746 217.774 343.593 217.049 344.499 216.323C344.982 215.9 345.466 215.538 345.949 215.115C346.795 214.39 347.642 213.664 348.427 212.879C348.911 212.456 349.334 212.033 349.817 211.549C351.268 210.159 352.657 208.648 353.987 207.138C354.531 206.473 355.135 205.808 355.679 205.143C359.547 200.369 362.629 195.232 364.684 189.733C368.551 179.157 368.431 167.131 361.964 153.896Z",
  fill: "#EB5757"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M325.749 191.64L315.999 192.221L323.231 194.287C320.648 196.805 318.582 198.807 315.547 201.454L301.342 200.228L312.19 204.36C308.638 207.266 306.831 208.815 302.956 211.204C296.693 209.525 289.978 208.04 289.978 208.04L298.307 214.045C293.594 216.693 288.751 218.759 283.973 219.727C283.198 219.856 283.973 219.727 283.198 219.856L274.482 216.951L278.162 220.696C258.081 223.408 252.528 215.982 252.528 215.982C252.528 215.982 252.593 215.595 252.722 214.885C252.851 214.304 253.045 213.593 253.432 212.625C254.724 208.944 258.017 202.487 265.959 194.287L266.475 201.132L269.187 192.286C269.897 191.769 270.672 191.188 271.447 190.671C273.965 188.928 273.513 188.863 276.548 187.637L277.194 197.193L281.003 185.764C282.811 185.054 284.748 184.408 286.685 183.892L285.2 193.06L291.205 182.859C294.885 181.89 296.241 181.696 299.986 181.18L298.372 190.671L305.023 180.663C310.705 179.953 310.511 180.082 315.418 179.953L313.029 187.895L319.357 179.63C327.622 179.63 335.886 180.211 335.886 180.211C335.886 180.211 332.529 184.731 325.749 191.64Z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M304.183 151.93L297.92 156.966L303.731 154.9C303.215 157.806 302.763 160.13 301.988 163.359L291.851 169.364L301.084 166.975C300.115 170.59 299.599 172.527 298.178 176.014C293.207 177.887 287.977 180.082 287.977 180.082L296.435 180.147C294.563 184.214 292.303 187.895 289.591 190.8C289.139 191.252 289.591 190.8 289.139 191.252L281.907 193.512L286.169 194.223C274.03 205.651 266.798 203.262 266.798 203.262C266.798 203.262 266.669 203.004 266.411 202.423C266.217 201.971 266.023 201.39 265.765 200.615C264.861 197.516 263.957 191.64 265.442 182.342L269.058 186.668L266.669 179.436C266.927 178.726 267.121 178.016 267.444 177.241C268.283 174.852 267.96 175.046 269.381 172.721L274.353 178.791L271.447 169.364C272.351 168.008 273.319 166.716 274.353 165.425L277.71 172.269L276.871 162.584C278.872 160.195 279.647 159.42 281.972 157.225L285.394 164.392L285.071 154.513C288.558 151.349 288.428 151.478 291.721 149.089L293.852 155.546L294.175 146.958C299.663 143.02 305.539 139.468 305.539 139.468C305.539 139.468 305.475 144.053 304.183 151.93Z",
  fill: "#232651"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.2133 146.894L32.93 151.349L25.5046 150.381C26.8606 153.738 27.9582 156.321 29.7662 160.001L43.3256 164.521L31.6387 164.005C33.7694 168.072 34.8025 170.203 37.4498 173.948C43.8422 174.852 50.6219 176.208 50.6219 176.208L40.6137 178.403C43.9067 182.729 47.5226 186.539 51.5258 189.315C52.1715 189.767 51.5258 189.38 52.1715 189.767L61.3403 190.607L56.4331 192.544C73.802 203.004 81.8086 198.355 81.8086 198.355C81.8086 198.355 81.9377 197.968 82.0668 197.257C82.196 196.676 82.2605 195.901 82.3251 194.933C82.5834 191.059 82.196 183.827 78.0636 173.173L74.8351 179.243L75.8682 170.009C75.4163 169.235 74.9643 168.395 74.4477 167.62C72.8335 164.973 73.2855 165.167 70.961 162.778L66.5058 171.365L67.5389 159.356C66.1184 158 64.6333 156.644 63.0836 155.352L60.8237 164.327L59.4032 152.64C56.3685 150.316 55.2708 149.541 51.9778 147.604L49.7179 156.967L47.5871 145.15C42.6153 142.245 42.8091 142.439 38.2892 140.372L37.3853 148.573L34.8671 138.435C27.248 135.207 19.3706 132.495 19.3706 132.495C19.3706 132.495 20.7265 137.854 24.2133 146.894Z",
  fill: "url(#paint1_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.3191 86.5867C37.9664 90.1379 39.1932 94.916 38.6121 99.2421C38.8704 100.017 39.1287 100.856 39.4515 101.825C41.0657 97.8862 43.9067 94.4641 47.3289 91.8813C46.2958 96.2074 43.3902 100.275 39.7098 102.6C40.2263 104.149 40.8074 105.957 41.5177 108.023C41.8405 108.927 42.1634 109.896 42.4862 110.929C42.6799 111.381 42.8091 111.898 43.0028 112.414C45.8438 106.797 50.5573 102.406 55.9811 99.3713C53.8503 105.312 48.8785 110.413 43.1319 112.737C43.261 113.189 43.4548 113.576 43.5839 114.028C44.3587 116.224 45.2627 118.484 46.1666 120.873C46.6186 121.97 47.006 123.068 47.458 124.166C50.2345 117.192 55.4 111.446 61.5986 107.249C59.8552 114.739 54.5606 121.518 47.8454 125.199C48.8785 127.782 50.0408 130.429 51.2676 133.141C51.3321 133.141 51.3321 133.205 51.3967 133.205H51.3321C51.7196 134.109 52.1715 135.078 52.6235 135.982C52.6881 136.046 52.6881 136.175 52.7527 136.24C55.5937 128.233 61.9214 121.195 69.6051 117.838C66.4412 125.909 60.5009 132.624 53.3338 137.338C55.5291 141.987 57.7244 146.248 59.8552 150.058C60.0489 150.381 60.1781 150.703 60.3718 150.962C62.1151 140.695 68.5074 130.945 77.2242 125.457C74.8352 135.788 68.7657 144.828 60.8237 151.737C61.6631 153.157 62.438 154.578 63.2128 155.869C63.7293 156.773 64.2459 157.612 64.7624 158.452C65.279 159.226 65.731 160.001 66.1829 160.776C66.1829 160.776 66.1829 160.841 66.2475 160.841C69.0885 151.349 76.1911 142.826 85.037 138.629C81.6794 148.121 75.0289 155.998 66.8286 161.745C70.1862 167.039 72.317 170.009 72.2524 170.332C72.1878 170.526 70.5091 168.718 67.7326 164.973C60.3072 168.589 51.8487 169.364 43.7776 167.943C50.5573 163.553 59.5324 162.197 67.2806 164.327C66.8286 163.746 66.3766 163.101 65.9247 162.39C65.9247 162.39 65.8601 162.39 65.8601 162.455V162.39C65.8601 162.326 65.7955 162.326 65.7955 162.261C65.3436 161.551 64.827 160.776 64.3105 160.001C63.7939 159.226 63.2774 158.323 62.6962 157.483C62.5025 157.16 62.3088 156.837 62.1151 156.515C52.1715 159.549 41.4531 158.968 31.6387 155.74C40.8074 151.543 52.0424 151.414 61.3403 155.159C60.6946 154.061 59.9843 152.899 59.2741 151.672C58.3701 150.122 57.4662 148.444 56.5622 146.7C46.1021 147.927 35.5774 145.344 26.4086 140.243C36.2876 137.854 47.458 139.791 55.9165 145.409C54.5606 142.826 53.2692 140.179 51.9133 137.273C51.3321 135.982 50.751 134.69 50.1699 133.399C41.7114 134.69 32.9946 133.012 25.3109 129.331C33.1883 126.942 42.2925 127.911 49.4596 131.785C48.1683 128.75 46.9415 125.78 45.8438 122.939C38.2247 122.551 30.6701 118.742 25.8921 112.931C32.9946 113.641 39.6452 116.74 45.1335 121.195C44.2941 118.871 43.4548 116.74 42.8091 114.609C42.4217 113.512 42.0342 112.414 41.7114 111.381C41.5823 110.929 41.4531 110.542 41.324 110.09C36.4168 110.606 31.5095 108.605 28.3457 104.666C32.9946 104.408 37.3853 106.151 41.0011 108.992C40.9366 108.798 40.872 108.54 40.8074 108.346C40.2263 106.345 39.7098 104.537 39.2578 102.923C39.2578 102.923 39.2578 102.923 39.2578 102.858C39.1932 102.6 39.1286 102.341 39.0641 102.148C34.8025 101.05 30.7993 98.0799 28.6039 94.3995C32.5426 95.5617 36.0294 97.9508 38.8058 100.921C38.6767 100.404 38.5475 99.8878 38.4184 99.4358C35.9648 95.5617 35.0608 91.0419 35.3191 86.5867Z",
  fill: "#232651"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.9279 42.5508C73.0918 45.5855 77.7408 47.3288 82.0669 47.2643C82.7771 47.5871 83.6165 47.9745 84.5205 48.3619C80.3881 49.5242 76.6431 51.9132 73.7375 55.0125C78.1282 54.496 82.5188 52.1069 85.2307 48.6848C86.7158 49.395 88.4592 50.1699 90.3962 51.0738C91.3002 51.5258 92.2042 51.9132 93.1727 52.4298C93.6247 52.6235 94.0766 52.8818 94.5286 53.14C88.6529 55.2708 83.6811 59.4678 80.0652 64.5687C86.1993 63.1482 91.8813 58.8221 94.8515 53.3337C95.2389 53.5274 95.6909 53.7211 96.0783 53.9794C98.1445 55.0125 100.275 56.1102 102.535 57.337C103.568 57.8535 104.601 58.4347 105.634 59.0158C98.4028 61.0174 92.075 65.4081 87.1678 71.0901C94.7869 70.1862 102.212 65.7955 106.603 59.5323C109.057 60.8883 111.575 62.3088 114.093 63.8584C114.093 63.923 114.158 63.923 114.158 63.9876V63.923C115.061 64.4396 115.901 64.9561 116.805 65.5372C116.869 65.6018 116.999 65.6664 117.063 65.6664C108.798 67.5388 101.05 73.0272 96.8531 80.2589C105.247 78.0636 112.543 72.9626 118.096 66.3766C122.422 69.0885 126.426 71.8004 129.977 74.3186C130.235 74.5123 130.558 74.706 130.816 74.9643C120.421 75.4808 109.961 80.7109 103.568 88.7174C114.093 87.5552 123.778 82.5834 131.591 75.4808C132.947 76.4493 134.238 77.4179 135.401 78.3218C136.24 78.9675 137.015 79.5486 137.79 80.1298C138.5 80.7109 139.21 81.292 139.92 81.8085C139.92 81.8085 139.985 81.8085 139.985 81.8731C130.235 83.5519 120.937 89.6214 115.707 97.8862C125.522 95.6908 134.174 89.9442 140.76 82.5188C145.602 86.4575 148.314 88.9111 148.702 88.9111C148.895 88.9111 147.281 86.974 143.859 83.8102C148.314 76.9013 150.058 68.5719 149.606 60.3717C144.44 66.6349 142.051 75.3517 143.278 83.2936C142.697 82.7771 142.116 82.2605 141.535 81.6794L141.599 81.6148H141.535C141.47 81.6148 141.47 81.5503 141.406 81.5503C140.76 80.9691 140.05 80.388 139.339 79.8069C138.629 79.2258 137.79 78.5801 137.015 77.9344C136.757 77.6761 136.434 77.4824 136.111 77.2242C140.308 67.7326 140.954 57.0141 138.887 46.8123C133.657 55.3999 132.172 66.5703 134.884 76.2556C133.851 75.4808 132.753 74.6414 131.656 73.802C130.171 72.7689 128.685 71.6712 127.071 70.509C129.525 60.3071 128.169 49.5242 124.166 39.8389C120.614 49.3305 121.26 60.6946 125.844 69.7342C123.455 68.12 120.937 66.4412 118.225 64.827C116.999 64.0521 115.772 63.3419 114.61 62.6316C116.934 54.3668 116.224 45.5209 113.447 37.4498C110.154 45.0044 110.025 54.1086 113.06 61.7277C110.219 60.1134 107.378 58.5638 104.73 57.1433C105.182 49.5887 102.341 41.5822 97.1114 36.1584C96.9822 43.3256 99.2421 50.2344 103.052 56.2393C100.856 55.1417 98.7902 54.044 96.7885 53.14C95.6909 52.6235 94.7223 52.1715 93.6892 51.7195C93.2373 51.5258 92.8498 51.3321 92.4624 51.203C93.5601 46.4249 92.1396 41.2594 88.5883 37.7081C87.8135 42.2925 88.9757 46.8123 91.4293 50.751C91.2356 50.6864 90.9773 50.5573 90.7836 50.4927C88.8466 49.6533 87.1032 48.9431 85.6181 48.2974C85.6181 48.2974 85.6181 48.2974 85.5536 48.2974C85.2953 48.2328 85.1016 48.1037 84.8433 48.0391C84.1976 43.6484 81.8086 39.3869 78.3864 36.7396C79.0967 40.7428 81.0338 44.4878 83.6811 47.5871C83.1645 47.3934 82.7126 47.1997 82.2606 47.0706C78.8384 44.165 74.3832 42.809 69.9279 42.5508Z",
  fill: "#232651"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278.808 87.297V213.852C278.808 214.497 278.743 215.143 278.549 215.724C277.71 219.017 274.74 221.471 271.189 221.471H69.2823C65.0853 221.471 61.6631 218.049 61.6631 213.852V87.297C61.6631 83.1 65.0853 79.6779 69.2823 79.6779H271.189C275.386 79.7424 278.808 83.1 278.808 87.297Z",
  fill: "url(#paint2_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278.808 87.297V193.965C265.377 192.35 252.012 187.895 241.745 179.178C230.317 169.558 223.279 153.996 226.313 139.404C218.63 159.937 193.577 170.72 172.076 166.265C150.574 161.809 133.141 144.957 123.326 125.263C118.096 114.868 110.348 96.1429 109.186 79.6779H271.189C275.386 79.7424 278.808 83.1 278.808 87.297Z",
  fill: "url(#paint3_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M278.549 215.724C277.71 219.017 274.74 221.471 271.189 221.471H69.2823C65.0853 221.471 61.6631 218.049 61.6631 213.852V198.032C63.0191 200.034 64.5687 201.842 66.3767 203.391C74.3186 210.365 85.3599 213.012 95.9491 212.948C106.538 212.883 116.934 210.429 127.394 208.428C160.712 202.035 194.933 200.098 228.702 202.81C245.813 204.231 263.957 207.459 278.549 215.724Z",
  fill: "#DE624C"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.411 130.623H83.1645C81.1629 130.623 79.6133 129.008 79.6133 127.071V101.825C79.6133 99.8233 81.2275 98.2737 83.1645 98.2737H108.411C110.413 98.2737 111.962 99.8879 111.962 101.825V127.071C112.027 129.008 110.413 130.623 108.411 130.623Z",
  fill: "#FDA859"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.765 129.267H83.8748C82.2606 129.267 80.9692 127.975 80.9692 126.361V102.471C80.9692 100.856 82.2606 99.5651 83.8748 99.5651H107.765C109.379 99.5651 110.671 100.856 110.671 102.471V126.361C110.606 127.975 109.315 129.267 107.765 129.267Z",
  fill: "#FFCD4B"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.115 124.747H90.4608C88.7174 124.747 87.2969 123.326 87.2969 121.583V107.184C87.2969 105.441 88.7174 104.02 90.4608 104.02H101.115C102.858 104.02 104.279 105.441 104.279 107.184V121.583C104.214 123.326 102.858 124.747 101.115 124.747ZM90.4608 106.797C90.2671 106.797 90.0734 106.99 90.0734 107.184V121.583C90.0734 121.777 90.2671 121.97 90.4608 121.97H101.115C101.308 121.97 101.502 121.777 101.502 121.583V107.184C101.502 106.99 101.308 106.797 101.115 106.797H90.4608Z",
  fill: "#FDA859"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.7174 107.894H80.9692V110.671H88.7174V107.894Z",
  fill: "#FDA859"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.7174 113.06H80.9692V115.836H88.7174V113.06Z",
  fill: "#FDA859"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.7174 118.225H80.9692V121.002H88.7174V118.225Z",
  fill: "#FDA859"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.606 107.894H102.858V110.671H110.606V107.894Z",
  fill: "#FDA859"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.606 113.06H102.858V115.836H110.606V113.06Z",
  fill: "#FDA859"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.606 118.225H102.858V121.002H110.606V118.225Z",
  fill: "#FDA859"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.6811 145.732V154.772H81.3566V147.669H79.6133V145.732H83.6811Z",
  fill: "white"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.6892 151.93C93.6892 153.674 92.2687 154.9 90.0088 154.9C88.7174 154.9 87.3615 154.448 86.4575 153.803L87.4261 151.995C88.1363 152.705 88.9757 153.093 89.8151 153.093C90.7836 153.093 91.3647 152.705 91.3647 151.995C91.3647 151.285 90.7836 150.897 89.8151 150.897H88.2654V149.606L90.3962 147.604H86.9095V145.796H93.2372V147.152L90.7836 149.412L91.2356 149.477C92.6561 149.67 93.6892 150.574 93.6892 151.93Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.76 150.251C101.76 153.222 100.469 154.836 98.209 154.836C95.9491 154.836 94.6577 153.222 94.6577 150.251C94.6577 147.281 95.8846 145.667 98.209 145.667C100.533 145.667 101.76 147.346 101.76 150.251ZM96.9822 150.251C96.9822 152.318 97.3696 153.157 98.2736 153.157C99.1776 153.157 99.565 152.318 99.565 150.251C99.565 148.185 99.1776 147.346 98.2736 147.346C97.3051 147.346 96.9822 148.185 96.9822 150.251Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.896 145.732V147.346L106.474 154.771H104.02L107.313 147.669H104.795V148.96H102.664V145.796H109.896V145.732Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.169 153.093C129.589 153.093 130.235 152.189 130.235 150.703C129.783 151.285 129.137 151.672 128.169 151.672C126.426 151.672 125.328 150.51 125.328 148.766C125.328 146.894 126.619 145.667 128.621 145.667C131.01 145.667 132.43 147.346 132.43 150.122C132.43 153.028 130.816 154.9 128.363 154.9C127.394 154.9 126.232 154.578 125.522 154.126L126.426 152.511C126.813 152.899 127.459 153.093 128.169 153.093ZM127.394 148.766C127.394 149.541 127.846 149.993 128.621 149.993C129.525 149.993 129.977 149.477 129.977 148.702C129.977 148.056 129.589 147.475 128.685 147.475C127.846 147.475 127.394 147.992 127.394 148.766Z",
  fill: "white"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.112 145.732V154.771H135.788V147.669H134.045V145.732H138.112Z",
  fill: "white"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146.054 145.732V154.771H143.73V147.669H141.987V145.732H146.054Z",
  fill: "white"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.063 151.93C156.063 153.674 154.642 154.9 152.382 154.9C151.091 154.9 149.735 154.448 148.831 153.803L149.799 151.995C150.51 152.705 151.349 153.093 152.189 153.093C153.157 153.093 153.738 152.705 153.738 151.995C153.738 151.285 153.157 150.897 152.189 150.897H150.639V149.606L152.77 147.604H149.283V145.796H155.611V147.152L153.157 149.412L153.609 149.477C155.094 149.67 156.063 150.574 156.063 151.93Z",
  fill: "white"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M178.985 150.251C178.985 153.222 177.693 154.836 175.433 154.836C173.173 154.836 171.882 153.222 171.882 150.251C171.882 147.281 173.109 145.667 175.433 145.667C177.693 145.667 178.985 147.346 178.985 150.251ZM174.142 150.251C174.142 152.318 174.529 153.157 175.433 153.157C176.337 153.157 176.725 152.318 176.725 150.251C176.725 148.185 176.337 147.346 175.433 147.346C174.529 147.346 174.142 148.185 174.142 150.251Z",
  fill: "white"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.375 149.025C185.506 149.025 186.862 150.122 186.862 151.737C186.862 153.609 185.377 154.9 183.181 154.9C181.955 154.9 180.599 154.448 179.63 153.738L180.599 151.93C181.309 152.705 182.148 153.093 182.923 153.093C183.827 153.093 184.344 152.705 184.344 151.93C184.344 151.22 183.827 150.833 182.923 150.833C182.471 150.833 180.986 150.833 180.405 150.897V145.732H186.474V147.604H182.6V148.96C182.729 149.025 183.181 149.025 183.375 149.025Z",
  fill: "white"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.542 153.093C191.963 153.093 192.609 152.189 192.609 150.703C192.157 151.285 191.511 151.672 190.542 151.672C188.799 151.672 187.701 150.51 187.701 148.766C187.701 146.894 188.993 145.667 190.994 145.667C193.383 145.667 194.804 147.346 194.804 150.122C194.804 153.028 193.19 154.9 190.736 154.9C189.767 154.9 188.605 154.578 187.895 154.126L188.799 152.511C189.251 152.899 189.897 153.093 190.542 153.093ZM189.767 148.766C189.767 149.541 190.219 149.993 190.994 149.993C191.898 149.993 192.35 149.477 192.35 148.702C192.35 148.056 191.963 147.475 191.059 147.475C190.284 147.475 189.767 147.992 189.767 148.766Z",
  fill: "white"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.034 148.379C200.034 147.862 199.647 147.604 199.001 147.604C198.291 147.604 197.322 148.056 196.483 148.766L195.579 147.023C196.741 146.184 197.968 145.667 199.324 145.667C201.132 145.667 202.488 146.636 202.488 148.056C202.488 149.025 201.713 150.058 200.744 151.091L198.872 152.963H202.746V154.836H195.902V153.286L199.195 149.929C199.647 149.348 200.034 148.766 200.034 148.379Z",
  fill: "white"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M222.762 148.379C222.762 147.862 222.375 147.604 221.729 147.604C221.019 147.604 220.05 148.056 219.211 148.766L218.307 147.023C219.469 146.184 220.696 145.667 222.052 145.667C223.86 145.667 225.216 146.636 225.216 148.056C225.216 149.025 224.441 150.058 223.472 151.091L221.6 152.963H225.474V154.836H218.63V153.286L221.923 149.929C222.375 149.348 222.762 148.766 222.762 148.379Z",
  fill: "white"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M233.61 145.732V147.346L230.187 154.771H227.734L231.027 147.669H228.509V148.96H226.443V145.796H233.61V145.732Z",
  fill: "white"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M239.163 145.732V154.771H236.838V147.669H235.03V145.732H239.163Z",
  fill: "white"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M247.105 145.732V154.771H244.716V147.669H242.972V145.732H247.105Z",
  fill: "white"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.196 171.172V176.983H80.7109V172.399H79.6133V171.172H82.196Z",
  fill: "white"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.2969 171.172V176.983H85.8118V172.399H84.7142V171.172H87.2969Z",
  fill: "white"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.6561 170.268L89.9442 177.887H88.7174L91.4293 170.268H92.6561Z",
  fill: "white"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.0452 172.851C95.0452 172.528 94.7869 172.334 94.3995 172.334C93.9475 172.334 93.3018 172.592 92.7853 173.044L92.2042 171.947C92.979 171.43 93.7538 171.043 94.5932 171.043C95.7554 171.043 96.5948 171.624 96.5948 172.592C96.5948 173.238 96.1429 173.884 95.4972 174.529L94.3349 175.692H96.7885V176.918H92.3333V175.885L94.4641 173.69C94.7869 173.496 95.0452 173.109 95.0452 172.851Z",
  fill: "white"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.825 175.175C101.825 176.273 100.921 177.048 99.4358 177.048C98.5964 177.048 97.6925 176.789 97.1759 176.337L97.7571 175.175C98.209 175.627 98.7902 175.885 99.3067 175.885C99.9524 175.885 100.275 175.627 100.275 175.175C100.275 174.723 99.8878 174.465 99.2421 174.465H98.2736V173.625L99.6295 172.334H97.4988V171.172H101.567V172.076L100.017 173.561L100.275 173.625C101.179 173.69 101.825 174.271 101.825 175.175Z",
  fill: "white"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.259 165.748L80.8401 167.491L81.4212 165.748H82.0669L81.0983 168.137H80.4527L79.4841 165.748H80.259Z",
  fill: "white"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.7457 167.75H82.7126L82.5189 168.202H81.8732L82.9063 165.812H83.552L84.5851 168.202H83.9394L83.7457 167.75ZM83.552 167.298L83.2291 166.458L82.9063 167.298H83.552Z",
  fill: "white"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85.4244 165.748V167.62H86.4575V168.137H84.7787V165.748H85.4244Z",
  fill: "white"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.4261 165.748V168.137H86.7804V165.748H87.4261Z",
  fill: "white"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.2025 166.975C90.2025 167.685 89.686 168.202 88.9112 168.202H87.8781V165.812H88.9112C89.686 165.748 90.2025 166.264 90.2025 166.975ZM89.5568 166.975C89.5568 166.587 89.2986 166.264 88.9112 166.264H88.5237V167.685H88.9757C89.2986 167.685 89.5568 167.427 89.5568 166.975Z",
  fill: "white"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.1081 165.748V166.264H91.9459V166.781H93.0436V167.298H91.9459V168.202H91.3002V165.812H93.1081V165.748Z",
  fill: "white"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.8515 168.202L94.5286 167.556H94.0767V168.202H93.431V165.812H94.5286C95.1743 165.812 95.5617 166.135 95.5617 166.652C95.5617 167.039 95.4326 167.298 95.1098 167.427L95.6263 168.202H94.8515ZM94.0121 167.039H94.4641C94.7223 167.039 94.8515 166.91 94.8515 166.652C94.8515 166.394 94.7223 166.264 94.4641 166.264H94.0121V167.039Z",
  fill: "white"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.3382 166.975C98.3382 167.685 97.7571 168.202 97.0468 168.202C96.272 168.202 95.7554 167.685 95.7554 166.975C95.7554 166.264 96.3366 165.748 97.0468 165.748C97.8216 165.748 98.3382 166.264 98.3382 166.975ZM96.4011 166.975C96.4011 167.362 96.724 167.685 97.0468 167.685C97.4342 167.685 97.6925 167.362 97.6925 166.975C97.6925 166.587 97.4342 166.264 97.0468 166.264C96.6594 166.264 96.4011 166.587 96.4011 166.975Z",
  fill: "white"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.3713 165.748L100.017 167.168L100.663 165.748H101.373V168.137H100.792V166.587L100.211 167.879H99.8233L99.2422 166.587V168.137H98.661V165.748H99.3713Z",
  fill: "white"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M241.681 204.683C236.967 204.683 233.158 200.873 233.158 196.16C233.158 191.446 236.967 187.637 241.681 187.637C246.394 187.637 250.204 191.446 250.204 196.16C250.204 200.873 246.394 204.683 241.681 204.683ZM241.681 189.057C237.742 189.057 234.578 192.286 234.578 196.16C234.578 200.098 237.807 203.262 241.681 203.262C245.555 203.262 248.783 200.034 248.783 196.16C248.783 192.286 245.619 189.057 241.681 189.057Z",
  fill: "white"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252.464 204.683C247.75 204.683 243.941 200.873 243.941 196.16C243.941 191.446 247.75 187.637 252.464 187.637C257.177 187.637 260.987 191.446 260.987 196.16C260.987 200.873 257.177 204.683 252.464 204.683ZM252.464 189.057C248.525 189.057 245.361 192.286 245.361 196.16C245.361 200.098 248.59 203.262 252.464 203.262C256.402 203.262 259.566 200.034 259.566 196.16C259.631 192.286 256.402 189.057 252.464 189.057Z",
  fill: "white"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M178.436 192.35H82.7449C80.9797 192.35 79.5487 193.781 79.5487 195.546C79.5487 197.312 80.9797 198.743 82.7449 198.743H178.436C180.201 198.743 181.632 197.312 181.632 195.546C181.632 193.781 180.201 192.35 178.436 192.35Z",
  fill: "white"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.843 27.1188C197.548 27.1188 197.548 35.319 202.843 35.319C208.137 35.319 208.137 27.1188 202.843 27.1188Z",
  fill: "white"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M326.815 157.483C321.52 157.483 321.52 165.683 326.815 165.683C332.109 165.683 332.109 157.483 326.815 157.483Z",
  fill: "white"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.579 59.9198C151.284 59.9198 151.284 68.12 156.579 68.12C161.874 68.12 161.874 59.9198 156.579 59.9198Z",
  fill: "white"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M178.274 52.3007C176.337 52.3007 176.337 55.2708 178.274 55.2708C180.147 55.2708 180.147 52.3007 178.274 52.3007Z",
  fill: "white"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M235.934 12.139C233.997 12.139 233.997 15.1092 235.934 15.1092C237.871 15.1092 237.871 12.139 235.934 12.139Z",
  fill: "white"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347.541 156.902C345.604 156.902 345.604 159.872 347.541 159.872C349.478 159.872 349.478 156.902 347.541 156.902Z",
  fill: "white"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M308.122 26.9252C306.185 26.9252 306.185 29.8953 308.122 29.8953C310.059 29.8953 310.059 26.9252 308.122 26.9252Z",
  fill: "white"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M266.669 61.177C253.14 61.177 242.133 72.184 242.133 85.7132C242.133 99.2424 253.14 110.249 266.669 110.249C280.198 110.249 291.205 99.2422 291.205 85.713C291.205 72.1838 280.198 61.177 266.669 61.177Z",
  fill: "url(#paint4_linear)"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M266.669 61.177C253.14 61.177 242.133 72.184 242.133 85.7132C242.133 99.2424 253.14 110.249 266.669 110.249C280.198 110.249 291.205 99.2422 291.205 85.713C291.205 72.1838 280.198 61.177 266.669 61.177Z",
  stroke: "white"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M270.44 85.7131L271.178 84.9958L276.583 79.7455L276.583 79.7455C277.527 78.8284 277.527 77.3535 276.583 76.4361C275.623 75.5033 274.054 75.5031 273.093 76.4361C273.093 76.4361 273.093 76.4362 273.093 76.4362L267.688 81.6864L266.992 82.3633L266.295 81.6864L260.89 76.4362C260.89 76.4361 260.89 76.4361 260.89 76.4361C259.93 75.5033 258.361 75.5032 257.4 76.4361L270.44 85.7131ZM270.44 85.7131L271.178 86.4304M270.44 85.7131L271.178 86.4304M271.178 86.4304L276.582 91.6802L276.583 91.6802C277.527 92.5976 277.527 94.0725 276.583 94.9896L276.582 94.99C276.105 95.4535 275.476 95.6898 274.838 95.6898C274.2 95.6898 273.57 95.4536 273.093 94.9897L273.093 94.9896L267.688 89.7398L266.991 89.063L266.295 89.7398L260.89 94.9896L260.89 94.9899C260.413 95.4535 259.783 95.6898 259.145 95.6898C258.507 95.6898 257.878 95.4537 257.4 94.9897C256.456 94.0724 256.456 92.5974 257.4 91.6803L257.4 91.6803L262.805 86.4304L263.543 85.7131L262.805 84.9958L257.4 79.7455L257.4 79.7455M271.178 86.4304L257.4 79.7455M257.4 79.7455C256.456 78.8282 256.456 77.3533 257.4 76.4362L257.4 79.7455Z",
  fill: "white",
  stroke: "#FC1515",
  strokeWidth: 2
});

var _ref62 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 294.207,
  y1: 179.63,
  x2: 294.207,
  y2: 221.004,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 50.879,
  y1: 132.495,
  x2: 50.879,
  y2: 198.923,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0A49FA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#286FF9"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 107.792,
  y1: 79.6779,
  x2: 251.711,
  y2: 112.994,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 145.219,
  y1: 79.6779,
  x2: 257.989,
  y2: 104.978,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 317,
  y1: 144.805,
  x2: 246,
  y2: 68.8051,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.45978,
  stopColor: "#FF0000"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F44848"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 368,
    height: 243,
    viewBox: "0 0 368 243",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
};

export default __webpack_public_path__ + "static/media/payment.b93ae8a2.svg";
export { SvgComponent as ReactComponent };